import { Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaEye, FaDownload, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import { CollegeReport } from "../UniversityScreens/CollegeReport";
import { openScrutinyPdfInNewTab } from "../UniversityScreens/ScrutinityPdfGeneration";
import { openChangeOfManagementPdfInNewTab } from "../UniversityScreens/PdfForChangeofManagement";
import { viewImage } from "../../CommonUtils/viewImage";
import { AiOutlineSignature } from "react-icons/ai";
import { openBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { Table, Row, Col, Button, Modal } from "react-bootstrap";
import FirstLevelInspPreviewForShiftingPreview from "../UniversityScreens/FirstLevelInspPreviewForShiftingPreview";
import { initiateESign } from "../../CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import { digisignFunction } from "../../CommonUtils/DIGISIGN/digisignFunction";
import { useSelector } from "react-redux";
import { DashBoardCounts, GetNocServices } from "../../Reducers/AffiliationCommonservice";
import { getServiceFullName } from "../../CommonUtils/CommonValidations";
export default function FinalStatus() {
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);
  const Dashboardcounts = useSelector((state) => state?.commonMastersReducer?.DashboardCounts);
  console.log("Dashboardcounts", Dashboardcounts[0]?.phase1_conditional_approved)




  //    "phase1_conditional_approved": 0,
  //            "phase1_approved": 0,
  //           "phase1_def_identified": 0,
  // phase1_pending
  //           "phase1_total_count": 4,


  const [selectedRow, setSelectedRow] = useState(null);
  const [showShiftingModal, setShowShiftingModal] = useState(false);
  const [selectedCollCode, setSelectedCollCode] = useState(null);
  const [pdfData, setPdfData1] = useState({});
  const [societyName, setSocietyName] = useState([]);
  const [getAccomidation, setAccom] = useState([]);
  const [managementData, setManagementData] = useState([]);
  const [nocdata, setNocdata] = useState({});
  const [selectedDigi, setSelectedDigi] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedRowpre, setSelectedRowpre] = useState(null);
  const [pdfData2, setPdfData2] = useState({});
  const [pdfData3, setPdfData3] = useState({});
  const [ScrutinyPdfData, setScrutinyPdfData] = useState({});
  const [ScrutinyPdfData1, setScrutinyPdfData1] = useState({});
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");
  let navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");

  // ********** socity details***************
  function getShiftingScrutinyDetails(collCode, nocType) {
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          setPdfData1(res.data);
        } else {
          setPdfData1({});
        }
      })
      .catch((e) => {
        setPdfData1({});
      });
  }
  const [getOverallData, setOverallData] = useState([])
  function finalGetAfterSubmit(collCode) {
    let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;
        if (data && data.length > 0) {
          setPdfData2(data);
          setOverallData(res.data)

          console.log("tetstt", res.data)
        } else {
          setOverallData([])
        }
      })
      .catch((error) => { });
  }



  const iconBtn = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const previewBtn = {
    ...iconBtn,
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
  };

  function getProceedingsDetails(collCode, nocType, jdstatus) {
    const type = nocType?.toLowerCase();
    const status = jdstatus?.toLowerCase();
    let url;

    if (jdstatus === "Deficiencies Identified") {
      url = `${config.url.FAC_URL}generateDeficiencyPdf/${collCode}/${nocType}`;
    }
    else if (
      type === "management" &&
      (status === "approved" || status === "conditionally approved")
    ) {
      url = `${config.url.FAC_URL}managementproceedings/${collCode}/${nocType}`;
    }

    else if (type === "shifting" && status === "reject") {
      url = `${config.url.FAC_URL}shiftingRejectPdf/${collCode}/${nocType}`;
    }
    else if (type === "shifting") {
      url = `${config.url.FAC_URL}shiftingallotteampdf/${collCode}/${nocType}`;
    }
    else if (
      type === "eop" &&
      (status === "approved" || status === "conditionally approved")
    ) {
      url = `${config.url.FAC_URL}eopproceedings/${collCode}/${nocType}`;
    }
    CommonAxiosGet(url)
      .then((res) => {
        if ((res?.data?.scode === "01" && res?.data?.pdf) || (res?.data?.status === true && res?.data?.file)) {
          setPdfBase64(res.data.pdf || res.data.file);
          setShowPdfModal(true);
        } else {
          failureAlert("PDF not available.");
        }
      })
      .catch((err) => {
        console.error("Error fetching PDF:", err);
        failureAlert("Failed to load PDF.");
      });
  }
  const EopfetchDeficiencies = async (collCode) => {
    try {
      let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
      const res = await CommonAxiosGet(url);
      if (res && res.data && res.data.status === true && res.data.def) {

        if (Array.isArray(res.data.def)) {
          const mappedData = res.data.def.map((item, index) => {

            return {
              remarks: item.remarks || item.deficiency_description || item.deficiency
            };
          });

          // console.log("Mapped deficiencies:", mappedData);
          return mappedData;
        } else {
          // console.log("def is not an array, it's:", typeof res.data.def);
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in EopfetchDeficiencies:", error);
      return [];
    }
  };
  function getInspectionPdf(collCode, nocType) {

    CommonAxiosGet(
      `${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType}`
    )
      .then((res) => {
        if (res?.data?.pdf) {
          console.log("ress", res);

          openBase64Pdf(res?.data?.pdf);
        }
      })
  }
  async function openNewCollegeScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating scrutiny report PDF...</p>");
    try {
      const [collegeResponse, scrutinyResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`),
      ]);

      const clgDetails = collegeResponse?.data || {};
      const scrutinyData = scrutinyResponse?.data || {};

      setScrutinyPdfData(clgDetails);
      setScrutinyPdfData1(scrutinyData);
      setSelectedRow(row);

      await openScrutinyPdfInNewTab({ clgDetails, scrutinyData, rowData: row, previewWindow, });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open scrutiny report PDF", error);
      failureAlert("Failed to generate scrutiny report PDF.");
    }
  }

  async function openManagementScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }

    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }

    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating management scrutiny report PDF...</p>");

    try {
      const [collegeResponse, societyResponse, accommodationResponse, managementResponse, previewResponse, scrutinyDetailsResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getAccommodationAreaData/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getPreView?collCode=${collCode}&nocType=management`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetails/${collCode}/management`),
      ]);

      const collegeData = collegeResponse?.data || {};
      const societyData = societyResponse?.data?.societyName_status === true ? societyResponse?.data?.societyName || [] : [];
      const accommodationData = accommodationResponse?.data?.status === true ? accommodationResponse?.data?.data || [] : [];
      const managementPayload = managementResponse?.data?.scode === "01" ? managementResponse?.data || {} : {};
      const previewData = previewResponse?.data?.scode === "01" ? previewResponse?.data || {} : {};
      const scrutinyDetails = scrutinyDetailsResponse?.data?.status === true ? scrutinyDetailsResponse?.data || {} : {};

      setPdfData1(collegeData);
      setSocietyName(societyData);
      setAccom(accommodationData);
      setManagementData(managementPayload);
      setNocdata(previewData);
      setSelectedRow(row);

      await openChangeOfManagementPdfInNewTab({
        collCode,
        societyName: societyData,
        formValues: {},
        managementData: managementPayload,
        scrutinyDetails,
        mngmtScrutiny: managementPayload?.mngmtScrutiny || [],
        deficiencies: managementPayload?.mngmtScrutiny_def || [],
        accommodationRows: managementPayload?.mngmtScrutiny_accom || [],
        accommodationBaseRows: accommodationData,
        corpusFundInstall: scrutinyDetails?.corpusFundInstall || [],
        ugPrograms: scrutinyDetails?.ugCourses || [],
        pgPrograms: scrutinyDetails?.pgCourses || [],
        ugCorpusFunds: [],
        pgBefore: [],
        pgCorpusFunds: [],
        nocdata: previewData,
        apiValues: collegeData,
        parking: {},
        previewWindow,
      });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open management scrutiny report PDF", error);
      failureAlert("Failed to generate management scrutiny report PDF.");
    }
  }
  const Columns = [
    {
      id: "slNo",
      header: "Sl.No",
      size: 20,
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },
    {
      id: "mobile_email",
      header: "Contact Details",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>
          {row.original.mobile_no} <br /> {row.original.email}
        </div>
      ),
    },


    {
      id: "college_preview",
      header: "College Preview",
      enableExport: false,

      cell: ({ row }) => {
        const clgcode = row.original;

        return (
          <button
            style={previewBtn}
            title="View College"
            onClick={() => navigate("/CollegeDetails", { state: { clgcode } })}
          >
            <FaEye />
          </button>
        );
      },
    },
    {
      id: "inspection_preview",
      header: "Inspection Preview",
      enableExport: false,

      cell: ({ row }) => {
        const nocType = row.original.noc_type?.toLowerCase();
        const collCode = row.original.coll_code;

        const isShifting = nocType === "shifting";
        const isEOP = nocType === "eop";
        const isNewCollege = nocType === "new_college";
        const isManagement = nocType === "management";

        const handleView = async () => {
          if (isShifting) {
            // 🔹 Shifting logic
            setSelectedCollCode(collCode);
            setShowShiftingModal(true);
            getShiftingScrutinyDetails(collCode, nocType);
            finalGetAfterSubmit(collCode);
            setSelectedRow(row.original);
            getShiftingAddDetailsss(collCode);
            getSurveyNumberr(collCode);

          } else if (isEOP) {
            // 🔹 EOP logic (PDF)
            getInspectionPdf(collCode, nocType);

          } else if (isNewCollege) {
            openNewCollegeScrutinyPdf(row.original);
          } else if (isManagement) {
            openManagementScrutinyPdf(row.original);
          } else {
            setSelectedRow(row.original);
          }
        };

        return (
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button
              style={previewBtn}
              onClick={handleView}
              title={
                isShifting
                  ? "View Shifting Scrutiny"
                  : isEOP
                    ? "View Inspection PDF"
                    : isManagement
                      ? "View Management Scrutiny"
                      : "View Inspection"
              }
            >
              <FaEye />
            </button>
          </div>
        );
      },
    },
    {
      id: "jd_status",
      header: "JD Final Status",
      accessorKey: "jd_status",
      meta: { style: { textAlign: "left" } },
      cell: ({ row }) => {
        const statusColorMap = {
          "approved": "green",
          "deficiencies identified": "brown",
          "conditionally approved": "orange",
          "reject": "red",
        };

        const status = row.original.jd_status;
        const color = statusColorMap[status?.toLowerCase()] || "#313131";

        return (
          <div className="d-flex gap-2">
            <span style={{ color, fontWeight: 500 }}>
              {status || "-"}
            </span>
          </div>
        );
      },
    },



    {
      id: "final_status",
      header: "Section Status",
      accessorKey: "final_status",
      cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span style={{ color: "green" }}>{row.original.final_status || "-"}</span>

        </div >
      ),
    },

    // {
    //   id: "digi_sign",
    //   header: (
    //     <>
    //       Digital Signature <AiOutlineSignature size={20} />
    //     </>
    //   ),
    //   enableExport: false,

    //   cell: ({ row }) => {
    //     const pdfPath = row.original?.final_pdf_sign;

    //     if (pdfPath) {
    //       return (
    //         <button
    //           type="button"
    //           className="btn btn-success btn-sm"
    //           onClick={() => { viewImage(pdfPath) }}
    //           title="View Signed PDF"
    //         >
    //           <i className="fa fa-file-pdf-o" /><FaDownload size={19} /> View Signed
    //         </button>
    //       );
    //     }

    //     return (
    //       <button
    //         type="button"
    //         className="btn btn-primary btn-sm"
    //         onClick={() => {
    //           setSelectedDigi(row.original || "");
    //           getProceedingsDetails(
    //             row.original.coll_code,
    //             row.original.noc_type,
    //             row.original.jd_status
    //           );
    //         }}
    //       >
    //         <i className="fa fa-file-pdf-o" /> Digi Sign
    //       </button>



    //     );
    //   },
    // }

    {
      id: "digi_sign",
      header: (
        <>
          Digital Signature <AiOutlineSignature size={20} />
        </>
      ),
      size: 150,
      minSize: 120,
      maxSize: 150,
      enableExport: false,

      cell: ({ row }) => {
        const { final_pdf_sign, coll_code, noc_type, jd_status } = row.original;

        if (final_pdf_sign) {
          return (
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={() => viewImage(final_pdf_sign)}
              title="View Signed PDF"
            >
              <i className="fa fa-file-pdf-o" />{" "}
              <FaDownload size={18} /> View Signed
            </button>
          );
        }

        return (
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                setSelectedDigi(row.original);
                getProceedingsDetails(
                  coll_code,
                  noc_type,
                  jd_status
                );
              }}
            >
              <i className="fa fa-file-pdf-o" /> Click here to Sign
            </button>


            {/* <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() =>
                initiateESign({
                  nocType: noc_type,
                  collCode: coll_code,
                  backtoscreen: "InspectionFinal",
                })
              }
            >
              E-Sign
            </button> */}
          </div>
        );
      },
    }

  ];
  const [inspstatus, setInspStatus] = useState([]);
  function GetInspectionStatus() {
    const endpoint = userId === "section_admin" ? "getsectionadmindata" : "getInspectionStatus";
    CommonAxiosGet(`${config.url.FAC_URL}${"getjdfinalstatus"}`).then((res) => {
      setInspStatus(res?.data?.scode === "01" ? res.data.data || [] : []);
    });
  }

  const degreeUniFormik = useFormik({
    initialValues: { collegesTableData: [], nocType: "eop" },
    onSubmit: (values) => { },
  });



  const filteredInspectionStatus = degreeUniFormik.values.nocType
    ? inspstatus.filter(
      (item) => String(item?.noc_type || "").toLowerCase() === String(degreeUniFormik.values.nocType).toLowerCase()
    )
    : inspstatus;


  async function dskConfirmationFunc() {
    if (!pdfBase64) {
      failureAlert("No PDF available for signing.");
      return;
    }

    try {
      const collCode = selectedDigi?.coll_code;
      const nocType = selectedDigi?.noc_type;

      if (!collCode || !nocType) {
        failureAlert("Missing college code or NOC type.");
        return;
      }

      let postData = {
        path: config.url.FAC_URL + "updateJdFinalStatus",
        params: {
          collCode: collCode,
          nocType: nocType,
          finalPdf: pdfBase64
        }
      };

      digisignFunction(pdfBase64, "-1", postData, "", "FinalStatus");
    } catch (error) {
      console.error("Error:", error);
      failureAlert("Digi sign failed.");
    }
  }



  useEffect(() => {
    GetInspectionStatus();
    GetNocServices();
    DashBoardCounts(degreeUniFormik?.values?.nocType);

  }, [degreeUniFormik?.values?.nocType]);

  const [shiftAddr, setShiftAddr] = useState([])
  function getShiftingAddDetailsss(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res?.data?.data || [];
          setShiftAddr(shiftData?.length > 0 && shiftData !== "No data found" ? shiftData : []);
          if (shiftData.length > 0) {
            const firstShift = shiftData[0];
            setShiftAddr({
              new_mandal: firstShift.mandal_name || firstShift.new_mandal,
              new_district: firstShift.new_dist || firstShift.new_district,
              new_pincode: firstShift.new_pincode,
              address_ofnew_location: firstShift.address_ofnew_location,
              shift_type: firstShift.shift_type,
              distance_from_existing: firstShift.distance_from_existing,
              justification: firstShift.justification
            });
          }
        } else {
          setShiftAddr([]);
        }
      })
      .catch((err) => {
        setShiftAddr([]);
      });
  }
  const [getSurvey, setSurvey] = useState([]);
  const getSurveyNumberr = async (collCode) => {
    let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res && res.data.status === true) {
        setSurvey(res.data.data[0] || res.data.data || []);
      } else {
        setSurvey([]);
      }
    } catch (err) {
      console.error("Error fetching survey number:", err);
      setSurvey([]);
    }
  };

  const totalcondition = degreeUniFormik?.values?.nocType === "shifting" ? Dashboardcounts[0]?.phase1_total_count_shifting : Dashboardcounts[0]?.phase1_total_count;

  const PendingCondition = degreeUniFormik?.values?.nocType === "shifting" ? Dashboardcounts[0]?.phase1_pending_shifting : Dashboardcounts[0]?.phase1_pending;
  const Headingcondition = degreeUniFormik?.values?.nocType === "shifting" ? "Recomended for physical Verification" : "Deficiency Identified";
  const Headingvalue = degreeUniFormik?.values?.nocType === "shifting" ? Dashboardcounts[0]?.phase1_shifting_recom : Dashboardcounts[0]?.phase1_def_identified;

  const headingCardClass = degreeUniFormik?.values?.nocType === "shifting"
    ? "recommended-card"
    : "deficiency-card";
  const TotalApproved = (Dashboardcounts[0]?.phase1_approved ?? 0) + (Dashboardcounts[0]?.phase1_conditional_approved ?? 0);

  return (
    <>

      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        size="xl"
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Inspection Preview - {selectedRowpre?.coll_code}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedRowpre && (
            <FirstLevelInspPreviewForShiftingPreview
              collCode={selectedRowpre.coll_code}
              nocType={selectedRowpre.noc_type}
              name="phase1"
              type="physical"
            />
          )}
        </Modal.Body>
      </Modal>


      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={degreeUniFormik}>
          <Form onSubmit={degreeUniFormik.handleSubmit} className="affl-form">
            <bie.Row className="px-2 pt-3 mb-3 w-100">
              <h5 className="mb-3 innerheader-new">
                <span>Final Status</span>
              </h5>
              <bie.Row>
                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                  <label className="form-label mb-0"
                    style={{ color: "#0f766e", fontWeight: 600, whiteSpace: "nowrap", marginBottom: 0, }}
                  > Select NOC Type </label>
                  <Field
                    as="select"
                    name="nocType"
                    className="form-control"
                    // onChange={degreeUniFormik.handleChange}
                    onChange={(e) => {
                      const value = e.target.value;
                      degreeUniFormik.setFieldValue("nocType", value);
                    }}
                  >
                    <option value="">--select--</option>
                    {/* <option value="eop">EOP</option>
                    <option value="new_college">New College</option>
                    <option value="management">Management Change</option>
                    <option value="shifting">Shifting</option> */}
                    {NocServicesOptions
                      ?.filter((service) => service.is_active)
                      .map((service) => (
                        <option
                          key={service.nos_short_name}
                          value={service.nos_short_name}
                        >
                          {service.full_name}
                        </option>
                      ))}

                  </Field>
                </bie.Col>
              </bie.Row>
              <bie.Col xs={12} className="mt-4">

                {filteredInspectionStatus?.length > 0 ? (
                  <>

                    <div className="dashboard-summary">

                      <div className="kpi-card total-card">
                        <div className="kpi-icon">
                          <i className="bi bi-grid-3x3-gap-fill"></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">Total Applications</div>
                          <div className="kpi-value">{totalcondition}</div>
                        </div>



                      </div>


                      {degreeUniFormik?.values?.nocType !== "shifting" && (
                        <div className="kpi-card approved-card">

                          <div className="card-heading">
                            <i className="bi bi-check-circle-fill me-2"></i>
                            Approved  ({TotalApproved})
                          </div>

                          <div className="split-section">

                            <div className="split-item">
                              <div className="split-title">
                                Approved
                              </div>

                              <div className="split-value">
                                {Dashboardcounts[0]?.phase1_approved}
                              </div>
                            </div>

                            <div className="split-line"></div>

                            <div className="split-item">
                              <div className="split-title">
                                Conditional
                              </div>

                              <div className="split-value">
                                {Dashboardcounts[0]?.phase1_conditional_approved}
                              </div>
                            </div>

                          </div>

                        </div>
                      )}




                      <div className={`kpi-card ${headingCardClass}`}>

                        <div className="kpi-icon">
                          <i
                            className={
                              degreeUniFormik?.values?.nocType === "shifting"
                                ? "bi bi-check-circle-fill"
                                : "bi bi-exclamation-triangle-fill"
                            }
                          ></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">
                            {Headingcondition}
                          </div>

                          <div style={{ fontSize: "25px", fontWeight: "bold" }}>
                            {Headingvalue}
                          </div>
                        </div>

                      </div>




                      <div className="kpi-card pending-card">

                        <div className="kpi-icon">
                          <i className="bi bi-hourglass-split"></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">
                            Pending
                          </div>

                          <div className="kpi-value">
                            {PendingCondition}
                          </div>
                        </div>

                      </div>

                      {degreeUniFormik?.values?.nocType === "shifting" && (

                        <div className="kpi-card rejected-card">

                          <div className="kpi-icon">
                            <i className="bi bi-x-circle-fill"></i>
                          </div>

                          <div className="kpi-content">
                            <div className="kpi-title">
                              Rejected
                            </div>

                            <div className="kpi-value">
                              {Dashboardcounts[0]?.phase1_shifting_reject}
                            </div>
                          </div>

                        </div>


                      )}
                    </div>


                    <div className="table-responsive">
                      <CommonReactTable
                        data={filteredInspectionStatus}
                        columns={Columns}
                        filename="AsiignInspectionToByUniversity"

                        headerName={`Final Status - ${getServiceFullName(
                          degreeUniFormik?.values?.nocType,
                          NocServicesOptions
                        )}`}
                        showFooter={false}
                        showPagination={false}
                        showExcel={true}
                        showPrint={false}
                        excelFileName="Inspection Status"
                      />
                    </div>
                  </>
                ) : (
                  <center className="text-danger h6">*** No Data Found ***</center>
                )}
              </bie.Col>
              <bie.Modal
                show={showShiftingModal}
                onHide={() => setShowShiftingModal(false)}
                size="xl"
                scrollable
              >
                <bie.Modal.Header closeButton>
                  <bie.Modal.Title>
                    {selectedRow?.noc_type === "shifting" && "Shifting Scrutiny Report"}
                  </bie.Modal.Title>
                </bie.Modal.Header>
                <bie.Modal.Body>
                  {selectedRow?.noc_type === "shifting" && (
                    <CollegeReport
                      apiData={pdfData}
                      apiData2={pdfData2}
                      rowData={selectedRow}
                      getOverallData={getOverallData}
                      getSurvey={getSurvey}
                      newAddData={shiftAddr}
                    />)}

                </bie.Modal.Body>
              </bie.Modal>
              <bie.Modal
                show={showPdfModal}
                onHide={() => setShowPdfModal(false)}
                size="xl"
                centered
              >
                <bie.Modal.Header closeButton>
                  <bie.Modal.Title>Proceedings PDF Preview</bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body style={{ height: "80vh", padding: 0 }}>
                  {pdfBase64 && (
                    <iframe
                      title="PDF Preview"
                      src={`data:application/pdf;base64,${pdfBase64}`}
                      width="100%"
                      height="100%"
                      style={{ border: "none" }}
                    />
                  )}
                </bie.Modal.Body>

                <bie.Modal.Footer>
                  <div className="d-flex justify-content-end gap-2 mt-3">

                    <button type="submit" className='btn btn-primary sign-btn'
                      onClick={dskConfirmationFunc}
                    > Digi Sign

                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary sign-btn"
                      onClick={() =>
                        initiateESign({
                          nocType: selectedDigi?.noc_type,
                          collCode: selectedDigi?.coll_code,
                          backtoscreen: "InspectionFinal",
                        })
                      }
                    >
                      E-Sign
                    </button>
                  </div>
                </bie.Modal.Footer>




              </bie.Modal>
            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container >
    </>
  );
}
